export default __webpack_public_path__ + "static/media/check.d639b7bb.svg";